module.exports = __webpack_public_path__ + "img/icon-nft-mew.97fed010.svg";